import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FaPlus } from 'react-icons/fa6'
import { useNavigate } from 'react-router-dom'

import { Button } from '../components/Button'
import { Card } from '../components/Card'
import { PreviewBlock } from '../components/Links/previewBlock'
import { DndContext, DragEndEvent, closestCenter } from '@dnd-kit/core'
import { SortableContext, arrayMove } from '@dnd-kit/sortable'
import { handleError } from '../helpers/handleError'
import { changeLinkOrder, getAllLinks } from '../services/links'

interface LinkInfo {
  id: number
  title: string
  link: string
}

export const AllLinks = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [links, setLinks] = useState<Links[] | []>([])

  const fetchLinks = async () => {
    try {
      const links: Links[] = await getAllLinks()
      const sortedLinks = links.sort((a, b) => a.order_id - b.order_id)
      setLinks(sortedLinks)
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    fetchLinks()
  }, [])

  const handleClick = () => {
    navigate('/link')
  }

  const handleDragEnd = async (event: DragEndEvent) => {
    const { active, over } = event
    if (!over) return

    const oldOrder = [...links]
    const oldIndex = links.findIndex((item) => item.id === active.id)
    const newIndex = links.findIndex((item) => item.id === over.id)

    const newOrder = arrayMove(links, oldIndex, newIndex)
    setLinks(newOrder)
    console.log(newOrder)

    try {
      await changeLinkOrder({ ids: newOrder.map((item) => item.id) })
    } catch (error) {
      handleError(error)

      setLinks(oldOrder)
    }
  }

  return (
    <div className="flex flex-col sm:flex-row">
      <div
        className="flex flex-col items-center justify-start overflow-scroll
        px-10 pb-10 sm:top-0 sm:ml-[100px] sm:w-[50%]"
        style={{ height: 'calc(100vh - 89px)' }}
      >
        <Button
          onClick={(handleClick)}
          className="mt-6 flex h-[48px] w-full items-center
          justify-center text-white"
          text={t('addLink')}
          type={'button'}
          icon={<FaPlus className="h-10 w-5" />}
        />

        {/* <div className="mb-10 sm:mb-8"> */}
        {links.length > 0 ? (
          <DndContext
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
          >
            <SortableContext items={links.map(({ id }) => id)}>
              <div className="w-full">
                {links.map((linkInfo: LinkInfo) => (
                  <Card
                    title={linkInfo.title}
                    link={linkInfo.link}
                    id={linkInfo.id}
                    key={linkInfo.id}
                  />
                ))}
              </div>
            </SortableContext>
          </DndContext>
        ) : (
          <p className="mt-[186px] text-center font-sans text-[18px] text-secondary">
            {t('fallbackLinksMessage_1')} <br /> {t('fallbackLinksMessage_2')}
          </p>
        )}
        {/* </div> */}
      </div>
      <div
        className="hidden w-[50%] items-center border-l border-gray-300 sm:flex"
        style={{ height: 'calc(100vh - 89px)' }}
      >
        <PreviewBlock />
      </div>
    </div>
  )
}
